//@ts-nocheck
import request from '../request';

export const getDiscountCodes = (params = {}) =>
  request({
    url: '/discount-codes',
    method: 'GET',
    params: {
      scope: 'global',
      ...params
    }
  });

export const getDiscountCode = (discountCodeId) =>
  request({
    url: `/discount-codes/${discountCodeId}`,
    method: 'GET'
  });

export const createDiscountCode = (discountCodeData) =>
  request({
    url: '/discount-codes',
    method: 'POST',
    data: discountCodeData
  });

export const updateDiscountCode = (discountCodeId, discountCodeData) =>
  request({
    url: `/discount-codes/${discountCodeId}`,
    method: 'PUT',
    data: discountCodeData
  });

export const deleteDiscountCode = (discountCodeId) =>
  request({
    url: `/discount-codes/${discountCodeId}`,
    method: 'DELETE'
  });

export const getTripDiscountCodes = (tripId, params = {}) =>
  request({
    url: `/trips/${tripId}/discount-codes`,
    method: 'GET',
    params
  });

export const createTripDiscountCode = (tripId, discountCodeData) =>
  request({
    url: `/trips/${tripId}/discount-codes`,
    method: 'POST',
    data: discountCodeData
  });

export const updateTripDiscountCode = (
  tripId,
  discountCodeId,
  discountCodeData
) =>
  request({
    url: `/trips/${tripId}/discount-codes/${discountCodeId}`,
    method: 'PUT',
    data: discountCodeData
  });

export const deleteTripDiscountCode = (tripId, discountCodeId) =>
  request({
    url: `/trips/${tripId}/discount-codes/${discountCodeId}`,
    method: 'DELETE'
  });

export const getTripDiscountCodesAvailableFromLibrary = (tripId) =>
  request({
    url: `/trips/${tripId}/discount-codes/available-from-library`,
    method: 'GET'
  });

export const createTripDiscountCodesFromLibrary = (tripId, discountCodeIds) =>
  Promise.all(
    discountCodeIds.map((sourceDiscountCodeId) =>
      request({
        url: `/trips/${tripId}/discount-codes/from-library`,
        method: 'POST',
        data: {
          sourceDiscountCodeId
        }
      })
    )
  );

export const validateTripDiscountCode = (tripId, discountCodeData) =>
  request({
    url: `/trips/${tripId}/discount-codes/validate`,
    method: 'POST',
    data: discountCodeData
  });

export const applyBookingDiscountCode = (bookingId, discountCodeData) =>
  request({
    url: `/bookings/${bookingId}/discount-codes`,
    method: 'POST',
    data: discountCodeData
  });

export const previewBookingDiscountCodes = (bookingId, discountCodeData) =>
  request({
    url: `/bookings/${bookingId}/discount-codes/preview`,
    method: 'POST',
    data: discountCodeData
  });

export const updateBookingDiscountCodes = (bookingId, discountCodeData) =>
  request({
    url: `/bookings/${bookingId}/discount-codes`,
    method: 'PUT',
    data: discountCodeData
  });

export const removeBookingDiscountCode = (bookingId, bookingDiscountId) =>
  request({
    url: `/bookings/${bookingId}/discount-codes/${bookingDiscountId}`,
    method: 'DELETE'
  });
